<template>
  <div class="cb-map-wrap">
    <!-- 顶部导航 -->
    <div class="top-header-area">
      <TopHeader :sqName="shengquName" :dbName="dibanName"/>
    </div>
    
    <!-- 主体内容 -->
    <div class="main-content">
     <LeftPanel :sqName="shengquName" :dbName="dibanName"/>

      <!-- 中间区域 - 三个区域 -->
      <div class="center-area">
       
        
        <!-- 第二块：中国地图 -->
        <div class="center-section center-section-2 border-box">
          <ContentMap :sqName="shengquName" :dbName="dibanName"/>
          <!-- <ContentMap /> -->
        </div>
        
        <!-- 第三块：底部统计 -->
        <div class="center-section center-section-3 border-box">
          <CenterBottomStats :sqName="shengquName" :dbName="dibanName"/>
        </div>
      </div>

      <!-- 右侧面板 - 三个区域 -->
      <RightPanel :sqName="shengquName" :dbName="dibanName"/>
    </div>
  </div>
</template>

<script>
import { getTime } from "@/utils";
import TopHeader from "./map/TopHeader.vue";
import LeftPanel from "./left/LeftPanel.vue";
import RightPanel from "./right/RightPanel.vue";
import CenterBottomStats from "./center/CenterBottomStats.vue";
import ContentMap from "./center/contentMap.vue";
// import CenterMap from "../../components/map/CenterMap.vue";

export default {
  name: 'MapScreen',
  components: {
    TopHeader,
    LeftPanel,
    RightPanel,
    CenterBottomStats,
    ContentMap
  },
  data() {
    return {
      currentDateTime: '',
      activeTab: 'all',
      shengquName: this.$store.getters.shengquName,
      dibanName: this.$store.getters.dibanName,
    }
  },
  watch: {
    '$store.getters.shengquName': {
      handler(newVal) {
        this.shengquName = newVal
      },
      immediate: true,
    },
    '$store.getters.dibanName': {
      handler(newVal) {
        this.dibanName = newVal
      },
      immediate: true,
    },
  },
  mounted() {
    this.updateDateTime()
    this.timer = setInterval(this.updateDateTime, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    updateDateTime() {
      this.currentDateTime = getTime()
    },
    formatNumber(num) {
      return Number(num).toLocaleString()
    },
    refreshData() {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'index.scss';


</style>
